import { SectionHeading } from "@/components/SectionHeading";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { GoldDiamond } from "@/components/icons";

const QUESTIONS = [
  "Who will check the property?",
  "Who will follow up with tenants?",
  "Who will collect rent?",
  "Who will inspect the property after a complaint?",
  "Who will coordinate plumbing?",
  "Who will arrange electrical repairs?",
  "Who will handle painting?",
  "Who will coordinate cleaning after a tenant vacates?",
  "Who will prepare the property for the next tenant?",
  "Who will verify the tenant?",
  "Who will coordinate the rental agreement?",
  "Who will send photos and videos?",
  "Who will make sure the work you paid for was actually completed?",
];

export const ValueProp = () => (
  <section className="bg-ivory py-24 sm:py-32" data-testid="value-prop-section">
    <div className="container-site grid gap-14 lg:grid-cols-[0.95fr_1.05fr] lg:gap-20">
      <div className="lg:sticky lg:top-32 lg:self-start">
        <SectionHeading
          chapter="01"
          eyebrow="The Real Problem"
          title="You Stay Abroad. We Stay Connected to Your Property."
        />
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-md text-base leading-relaxed text-muted-foreground sm:text-lg">
            Managing a property from another country is not difficult because of distance alone.
            The real problem is everything that needs a person on the ground.
          </p>
        </Reveal>
      </div>

      <div>
        <Stagger className="grid gap-3 sm:grid-cols-2" gap={0.05}>
          {QUESTIONS.map((q) => (
            <StaggerItem key={q}>
              <div className="flex h-full items-center gap-3 rounded-xl border border-navy-900/10 bg-white px-4 py-3.5">
                <GoldDiamond className="h-2 w-2 shrink-0 text-gold-500" />
                <span className="text-sm font-medium text-navy-900/85">{q}</span>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
        <Reveal delay={0.2}>
          <div className="mt-8 rounded-2xl border-l-2 border-gold-500 bg-navy-900 p-7 sm:p-8">
            <p className="font-display text-xl font-bold leading-snug tracking-tight text-white sm:text-2xl">
              That is where NRI Property Services comes in.
            </p>
            <p className="mt-3 text-sm leading-relaxed text-white/65 sm:text-base">
              We act as your local property representative in Hyderabad — physically present at your
              property, handling things on your behalf.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
